export default __webpack_public_path__ + "static/media/Coresight.dd6153ba.png";